import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApi from "./hooks/useApi";

interface InviteUserResponse {
  message: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    providerId: string;
    accountStatus: string;
  };
  password: string;
  passwordStatus: string;
  groupSettings: {
    status: string;
    rvuTrackerOptIn: boolean;
  };
}

interface ResetPasswordResponse {
  message: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  password: string;
  passwordStatus: string;
}

export const useInviteUserToGroup = () => {
  const queryClient = useQueryClient();
  const { requestFn } = useApi<InviteUserResponse>({
    url: "/group/inviteUserToGroup",
    method: "POST",
  });

  return useMutation({
    mutationFn: (data: {
      groupId: string;
      email: string;
      firstName: string;
      lastName: string;
      npi: string;
    }) => {
      return requestFn(data);
    },
    onSuccess: (response, variables) => {
      // Invalidate queries
      Promise.all([
        // Invalidate providers list
        queryClient.invalidateQueries({ queryKey: ["/group/providers", { id: variables.groupId }] }),

        // Invalidate other related queries
        queryClient.invalidateQueries({ queryKey: ["group", { id: variables.groupId }] }),
        queryClient.invalidateQueries({ queryKey: ["myGroups"] }),

        queryClient.refetchQueries({
          queryKey: ["/group/providers"],
          exact: false
        })
      ]);

      return response;
    },
    onError: (error) => {
      console.error("Error in invitation:", error);
    }
  });
};

export const useResetProviderPassword = () => {
  const { requestFn } = useApi<ResetPasswordResponse>({
    url: "/group/resetProviderPassword",
    method: "POST",
  });
  return useMutation({
    mutationFn: async (data: {
      groupId: string;
      groupMemberId: string;
    }) => {
      return await requestFn(data);
    },
    onError: (error) => {
      console.error("Error resetting password:", error);
    }
  });
};